import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { getStoredViewState, setViewState, getDefaultViewForPage } from '../../../utils/viewStateUtils';
import PipelineList from './pipelineList';
import PipelineGrid from './pipelineGrid';

type ViewType = 'list' | 'kanban';

const PipelineContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentViewFromUrl = (): ViewType => {
    if (location.pathname.includes('/pipelines/list') || location.pathname === '/pipelines') return 'list';
    if (location.pathname.includes('/pipelines/grid') || location.pathname.includes('/pipelines/kanban')) return 'kanban';
    return 'kanban';
  };

  const [currentView, setCurrentView] = useState<ViewType>(() => {
    const storedView = getStoredViewState('pipelines');
    if (storedView === 'list' || storedView === 'kanban') {
      return storedView as ViewType;
    }
    return getDefaultViewForPage('pipelines') as ViewType;
  });

  useEffect(() => {
    if (location.pathname === '/pipelines') {
      const storedView = getStoredViewState('pipelines');
      const viewToUse = (storedView || getDefaultViewForPage('pipelines')) as ViewType;
      const targetRoute = viewToUse === 'list' ? all_routes.pipelinesList : all_routes.pipelinesGrid;
      navigate(targetRoute, { replace: true });
      return;
    }

    const storedView = getStoredViewState('pipelines');
    if (storedView && (storedView === 'list' || storedView === 'kanban')) {
      const targetRoute = storedView === 'list' ? all_routes.pipelinesList : all_routes.pipelinesGrid;
      if (location.pathname !== targetRoute) {
        navigate(targetRoute, { replace: true });
      }
      setCurrentView(storedView as ViewType);
    } else {
      const defaultView = getDefaultViewForPage('pipelines') as ViewType;
      const targetRoute = defaultView === 'list' ? all_routes.pipelinesList : all_routes.pipelinesGrid;
      if (location.pathname !== targetRoute) {
        navigate(targetRoute, { replace: true });
      }
      setCurrentView(defaultView);
      setViewState('pipelines', defaultView);
    }
  }, [location.pathname, navigate]);

  const handleViewSwitch = (view: ViewType) => {
    setViewState('pipelines', view);
    setCurrentView(view);
    
    const targetRoute = view === 'list' ? all_routes.pipelinesList : all_routes.pipelinesGrid;
    navigate(targetRoute, { replace: true });
  };

  return (
    <>
      {currentView === 'list' ? (
        <PipelineList onViewSwitch={handleViewSwitch} />
      ) : (
        <PipelineGrid onViewSwitch={handleViewSwitch} />
      )}
    </>
  );
};

export default PipelineContainer;
